// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
	padding: 0;
	margin: 0;
}

body {
	width: 100%;
	height: 100%;
	display: grid;
	place-content: center;
	place-items: center;
	word-break: break-word;
	background-color: #181818;
	position: relative;	
	z-index: 1;
}

#container {
	display: grid;
	width: 100%;
	height: 100%;
	place-content: center;
	place-items: center;
}

#content {
	width: 80vw;
	max-width: 50rem;
	align-items: center;
	padding: clamp(0.75rem, 8vh, 10rem) clamp(0.5rem, 5vw, 8rem);
	display: flex;
	flex-flow: column;
	gap: 1rem;
	place-content: center;
	text-align: center;
	position: relative;
	z-index: 2;
}

#text-content {
	display: grid;
	gap: 4px;
}

#data {
	display: flex;
	width: 70vw;
	max-width: 25rem;
	flex-flow: column;
	background-color: rgb(0 0 0 / 30%);
	gap: 4px;
	padding: 0.5rem 1.5rem;
	border: 1px solid #e52626;
	border-radius: 4px;
	color: white;
}

.box {
	display: flex;
	justify-content: space-between;
}

.title {
	font-size: 1.75rem;
	font-family: 'Nunito', sans-serif;
	font-weight: 700;
}

h2 .title {
	font-size: 1.25rem;
}

.text, .title {
	color: white;
}

.desc {
	margin-bottom: 1.5rem;
}

.supertext {
	font-family: 'Nunito', sans-serif;
	font-weight: 700;
	font-size: 1.1rem;
}

#target {
	width: 50vw;
	height: 50vh;
	position: absolute;
	z-index: -1;
}

#github {
	width: clamp(0.5rem, 7vw, 1.25rem);
	height: clamp(0.5rem, 7vw, 1.25rem);
	background-color: #303030;
	clip-path: circle();
	padding: 0.5rem;
	transition: ease-out 200ms;
}

#icon:hover > #github {
	background-color: #202020;
}

#icon {
	display: flex;
	gap: 0.6rem;
	text-decoration: none;	
	place-content: center;
	align-items: center;
	width: 27vw;
	min-width: 7rem;
}

#icon:hover {
	color: #c7c7c7;
}

#profile {
	display: grid;
	place-content: center;
}

#warn {
	display: grid;
	width: 50vw;
	max-width: 50rem;
	align-items: end;
	gap: 0.5rem;
}

#info, #tag {
	white-space: nowrap;
	text-overflow: ellipsis;
}

`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;CACC,UAAU;CACV,SAAS;AACV;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,aAAa;CACb,qBAAqB;CACrB,mBAAmB;CACnB,sBAAsB;CACtB,yBAAyB;CACzB,kBAAkB;CAClB,UAAU;AACX;;AAEA;CACC,aAAa;CACb,WAAW;CACX,YAAY;CACZ,qBAAqB;CACrB,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,gBAAgB;CAChB,mBAAmB;CACnB,4DAA4D;CAC5D,aAAa;CACb,iBAAiB;CACjB,SAAS;CACT,qBAAqB;CACrB,kBAAkB;CAClB,kBAAkB;CAClB,UAAU;AACX;;AAEA;CACC,aAAa;CACb,QAAQ;AACT;;AAEA;CACC,aAAa;CACb,WAAW;CACX,gBAAgB;CAChB,iBAAiB;CACjB,kCAAkC;CAClC,QAAQ;CACR,sBAAsB;CACtB,yBAAyB;CACzB,kBAAkB;CAClB,YAAY;AACb;;AAEA;CACC,aAAa;CACb,8BAA8B;AAC/B;;AAEA;CACC,kBAAkB;CAClB,iCAAiC;CACjC,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,iCAAiC;CACjC,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,WAAW;AACZ;;AAEA;CACC,kCAAkC;CAClC,mCAAmC;CACnC,yBAAyB;CACzB,mBAAmB;CACnB,eAAe;CACf,0BAA0B;AAC3B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,aAAa;CACb,WAAW;CACX,qBAAqB;CACrB,qBAAqB;CACrB,mBAAmB;CACnB,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,aAAa;CACb,qBAAqB;AACtB;;AAEA;CACC,aAAa;CACb,WAAW;CACX,gBAAgB;CAChB,gBAAgB;CAChB,WAAW;AACZ;;AAEA;CACC,mBAAmB;CACnB,uBAAuB;AACxB","sourcesContent":["* {\n\tpadding: 0;\n\tmargin: 0;\n}\n\nbody {\n\twidth: 100%;\n\theight: 100%;\n\tdisplay: grid;\n\tplace-content: center;\n\tplace-items: center;\n\tword-break: break-word;\n\tbackground-color: #181818;\n\tposition: relative;\t\n\tz-index: 1;\n}\n\n#container {\n\tdisplay: grid;\n\twidth: 100%;\n\theight: 100%;\n\tplace-content: center;\n\tplace-items: center;\n}\n\n#content {\n\twidth: 80vw;\n\tmax-width: 50rem;\n\talign-items: center;\n\tpadding: clamp(0.75rem, 8vh, 10rem) clamp(0.5rem, 5vw, 8rem);\n\tdisplay: flex;\n\tflex-flow: column;\n\tgap: 1rem;\n\tplace-content: center;\n\ttext-align: center;\n\tposition: relative;\n\tz-index: 2;\n}\n\n#text-content {\n\tdisplay: grid;\n\tgap: 4px;\n}\n\n#data {\n\tdisplay: flex;\n\twidth: 70vw;\n\tmax-width: 25rem;\n\tflex-flow: column;\n\tbackground-color: rgb(0 0 0 / 30%);\n\tgap: 4px;\n\tpadding: 0.5rem 1.5rem;\n\tborder: 1px solid #e52626;\n\tborder-radius: 4px;\n\tcolor: white;\n}\n\n.box {\n\tdisplay: flex;\n\tjustify-content: space-between;\n}\n\n.title {\n\tfont-size: 1.75rem;\n\tfont-family: 'Nunito', sans-serif;\n\tfont-weight: 700;\n}\n\nh2 .title {\n\tfont-size: 1.25rem;\n}\n\n.text, .title {\n\tcolor: white;\n}\n\n.desc {\n\tmargin-bottom: 1.5rem;\n}\n\n.supertext {\n\tfont-family: 'Nunito', sans-serif;\n\tfont-weight: 700;\n\tfont-size: 1.1rem;\n}\n\n#target {\n\twidth: 50vw;\n\theight: 50vh;\n\tposition: absolute;\n\tz-index: -1;\n}\n\n#github {\n\twidth: clamp(0.5rem, 7vw, 1.25rem);\n\theight: clamp(0.5rem, 7vw, 1.25rem);\n\tbackground-color: #303030;\n\tclip-path: circle();\n\tpadding: 0.5rem;\n\ttransition: ease-out 200ms;\n}\n\n#icon:hover > #github {\n\tbackground-color: #202020;\n}\n\n#icon {\n\tdisplay: flex;\n\tgap: 0.6rem;\n\ttext-decoration: none;\t\n\tplace-content: center;\n\talign-items: center;\n\twidth: 27vw;\n\tmin-width: 7rem;\n}\n\n#icon:hover {\n\tcolor: #c7c7c7;\n}\n\n#profile {\n\tdisplay: grid;\n\tplace-content: center;\n}\n\n#warn {\n\tdisplay: grid;\n\twidth: 50vw;\n\tmax-width: 50rem;\n\talign-items: end;\n\tgap: 0.5rem;\n}\n\n#info, #tag {\n\twhite-space: nowrap;\n\ttext-overflow: ellipsis;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
